import React, { useState } from 'react';
import Login from './Login';
import ChatInterface from './ChatInterface';

/**
 * Root app component — full-page layout (no popup wrapper).
 * Replaces the old PopupChatbot.jsx.
 * Usage: render <App /> (or rename to match your existing entry point).
 */
export default function App() {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState('');
  const [casinoId, setCasinoId] = useState('');

  const handleLogin = (accessToken, user, casino) => {
    setToken(accessToken);
    setUserId(user);
    setCasinoId(casino);
  };

  const handleLogout = () => {
    setToken(null);
    setUserId('');
    setCasinoId('');
  };

  return token ? (
    <ChatInterface
      token={token}
      userId={userId}
      casinoId={casinoId}
      onLogout={handleLogout}
    />
  ) : (
    <Login onLogin={handleLogin} />
  );
}